import React from "react"
import "./bannerImage.scss"

const BannerImageCard = (props) => {
    return (
        <div className="bannerImageCard">
            <div className="bannerImageWidth">
                <img loading="lazy" className="bannerImage" src={props.url} />
            </div>
        </div>
    )
}

export default BannerImageCard
